import _styled from '@emotion/styled/base';
import { keyframes, css } from '@emotion/react';
import { Button } from '../Button/index.js';
import { Menu } from '../Menu/index.js';

const DRAG_ZINDEX = 9992;
const Wrapper = _styled("div", {
  target: "exatwhm8"
})({
  name: "da07or",
  styles: "display:flex;width:100%;box-sizing:border-box;justify-content:flex-start"
} );
var _ref10 = {
  name: "1f4bfhw",
  styles: "width:100%;grid-auto-flow:column"
} ;
var _ref11 = {
  name: "5v62bf",
  styles: "&:after{content:'';height:10px;grid-column-start:span var(--columns, 1);}"
} ;
const StyledListContainer = _styled("ul", {
  target: "exatwhm7"
})("display:grid;grid-auto-rows:max-content;box-sizing:border-box;width:100%;grid-gap:10px;padding-bottom:0;border-radius:5px;min-height:200px;transition:background-color 350ms ease;grid-template-columns:repeat(var(--columns, 1), 1fr);", ({
  customItem
}) => !customItem && _ref11, " ", ({
  horizontal
}) => horizontal && _ref10, ";");
const StyledGridContainer = _styled("ul", {
  target: "exatwhm6"
})({
  name: "b9ptqq",
  styles: "max-width:800px;display:grid;grid-template-columns:repeat(var(--col-count), 1fr);grid-gap:10px;padding:20px;@media (max-width: 850px){grid-template-columns:repeat(calc(var(--col-count) - 1), 1fr);}@media (max-width: 650px){grid-template-columns:repeat(calc(var(--col-count) - 2), 1fr);}"
} );
const popAnimation = keyframes`
  0% {
    transform: scale(1);
    box-shadow: var(--box-shadow);
  }
  100% {
    transform: scale(var(--scale));
    box-shadow: var(--box-shadow-picked-up);
  }
`;
const fadeInAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
var _ref9 = {
  name: "1g3fehb",
  styles: "--scale:1.05;--box-shadow:0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05),0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);--box-shadow-picked-up:0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05),-1px 0 15px 0 rgba(34, 33, 81, 0.01),0px 15px 15px 0 rgba(34, 33, 81, 0.25);z-index:999"
} ;
const StyledLi = _styled("li", {
  target: "exatwhm5"
})("display:flex;box-sizing:border-box;transform:translate3d(var(--translate-x, 0), var(--translate-y, 0), 0) scaleX(var(--scale-x, 1)) scaleY(var(--scale-y, 1));transform-origin:0 0;touch-action:manipulation;", ({
  fadeIn
}) => fadeIn && css("animation:", fadeInAnimation, " 500ms ease;"), " ", ({
  dragOverlay
}) => dragOverlay && _ref9, ";");
var _ref4 = {
  name: "29nxiu",
  styles: "color:#999;background-color:#f1f1f1;&:focus{box-shadow:0 0px 4px 1px rgba(0, 0, 0, 0.1),0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05),0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);}cursor:not-allowed"
} ;
var _ref5 = {
  name: "9w5p21",
  styles: "opacity:var(--dragging-opacity, 0.5);z-index:0;&:focus{box-shadow:0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05),0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);}"
} ;
var _ref6 = {
  name: "51kgiz",
  styles: "padding:16px;flex-grow:0"
} ;
var _ref7 = {
  name: "1i6h5fz",
  styles: "padding:10px 16px"
} ;
var _ref8 = {
  name: "1tc6u2t",
  styles: "touch-action:manipulation;cursor:grab"
} ;
const StyledItem = _styled("div", {
  target: "exatwhm4"
})("position:relative;display:flex;flex-grow:1;align-items:center;padding:18px 20px;background-color:#fff;box-shadow:0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05),0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);outline:none;border-radius:calc(4px / var(--scale-x, 1));box-sizing:border-box;list-style:none;transform-origin:50% 50%;-webkit-tap-highlight-color:transparent;color:#333;font-weight:400;font-size:1rem;white-space:nowrap;transform:scale(var(--scale, 1));transition:0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05),0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15) 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22);&:focus-visible{box-shadow:0 0px 4px 1px #4c9ffe,0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05),0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);}", ({
  withHandle
}) => !withHandle ? _ref8 : _ref7, " ", ({
  horizontal
}) => horizontal && _ref6, " ", ({
  dragging,
  dragOverlay
}) => dragging && !dragOverlay && _ref5, " ", ({
  disabled
}) => disabled && _ref4, " ", ({
  dragOverlay
}) => dragOverlay && css("cursor:inherit;animation:", popAnimation, " 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22);transform:scale(var(--scale));box-shadow:var(--box-shadow-picked-up);opacity:1;"), " ", ({
  color
}) => color && css("&:before{content:'';position:absolute;top:50%;transform:translateY(-50%);left:0;height:100%;width:3px;display:block;border-top-left-radius:3px;border-bottom-left-radius:3px;background-color:", color, ";}"), " &:hover{.remove-drag-item{visibility:visible;}}");
var _ref3 = {
  name: "1ogil4o",
  styles: "height:100%;align-items:start"
} ;
const StyledControls = _styled("span", {
  target: "exatwhm3"
})("display:flex;flex-grow:1;align-items:center;justify-content:right;", ({
  horizontal
}) => horizontal && _ref3, ";");
var _ref = {
  name: "6dhm9o",
  styles: "visibility:hidden"
} ;
var _ref2 = {
  name: "rlf1us",
  styles: "background-color:var(--background, rgba(0, 0, 0, 0.05));svg{fill:var(--fill, #788491);}"
} ;
const StyledControlButton = _styled(Button.Tertiary, {
  target: "exatwhm2"
})("display:flex;align-items:center;justify-content:center;flex:0 0 auto;touch-action:none;cursor:var(--cursor, pointer);border-radius:5px;border:none;outline:none;appearance:none;background-color:transparent;-webkit-tap-highlight-color:transparent;@media (hover: hover){&:hover{background-color:var(--action-background, rgba(0, 0, 0, 0.05));svg{fill:#6f7b88;}}}svg{flex:0 0 auto;margin:auto;height:100%;overflow:visible;}&:active{", ({
  activeStyle
}) => activeStyle ? css("background-color:", activeStyle.background, ";svg{fill:", activeStyle.fill, ";}") : _ref2, ";}&:focus-visible{outline:none;box-shadow:0 0 0 2px rgba(255, 255, 255, 0),0 0px 0px 2px #4c9ffe;}", ({
  hidden
}) => hidden && _ref, ";");
_styled(Menu.Item, {
  target: "exatwhm1"
})({
  name: "1p6ukdt",
  styles: "&:hover{.remove-drag-item{visibility:visible;}}"
} );
const DroppableContainer = _styled("div", {
  target: "exatwhm0"
})({
  name: "duudsh",
  styles: "position:fixed"
} );

export { DRAG_ZINDEX, DroppableContainer, StyledControlButton, StyledControls, StyledGridContainer, StyledItem, StyledLi, StyledListContainer, Wrapper };
